const COLUMN_ALIGNMENT = 8
const FNV_OFFSET_BASIS = 0x811c9dc5
const FNV_PRIME = 0x01000193

export interface ColumnPlacement {
  offset: number
  length: number
}

interface StoredColumn {
  offset: number
  bytes: Uint8Array
}

export class ColumnWriter {
  private readonly columns: StoredColumn[] = []
  private readonly columnsByContent = new Map<string, StoredColumn[]>()
  private size = 0

  add(data: Float64Array | Uint8Array): ColumnPlacement {
    const bytes = new Uint8Array(
      new Uint8Array(data.buffer, data.byteOffset, data.byteLength)
    )
    const key = `${bytes.byteLength}:${contentHash(bytes)}`
    const sameKey = this.columnsByContent.get(key) ?? []
    const stored = sameKey.find((column) => sameBytes(column.bytes, bytes))
    if (stored) return { offset: stored.offset, length: data.length }
    const column = { offset: this.size, bytes }
    this.columns.push(column)
    this.columnsByContent.set(key, [...sameKey, column])
    this.size = alignUp(column.offset + bytes.byteLength)
    return { offset: column.offset, length: data.length }
  }

  bytes(): Uint8Array {
    const all = new Uint8Array(this.size)
    for (const { offset, bytes } of this.columns) all.set(bytes, offset)
    return all
  }
}

export function alignUp(size: number): number {
  return Math.ceil(size / COLUMN_ALIGNMENT) * COLUMN_ALIGNMENT
}

function contentHash(bytes: Uint8Array): number {
  let hash = FNV_OFFSET_BASIS
  for (let i = 0; i < bytes.length; i++) {
    hash = Math.imul(hash ^ bytes[i], FNV_PRIME)
  }
  return hash >>> 0
}

function sameBytes(a: Uint8Array, b: Uint8Array): boolean {
  if (a.byteLength !== b.byteLength) return false
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) return false
  }
  return true
}
